import { useSetting } from "../../../util/useSetting"
export default function SettingPopup(props) {
    const { fontSize, updateFontSize } = useSetting()
    return (
        <div className='absolute inset-0 flex justify-center items-center p-[16px] bg-[black] z-[999]'>
            <div className='flex flex-col min-w-[600px] max-w-[90vw] rounded-[16px]'>
                <div className='w-full py-[8px] text-center font-[900] text-[#003A57] bg-[#D9F4F4]' style={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
                    設定
                </div>
                <div className='w-full flex flex-col justify-start items-center p-[16px] bg-[white]' style={{ backgroundImage: 'url(/secondary/bg5.png)', backgroundSize: 'cover', backgroundPosition: 'center', borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}>
                    <div className='font-slider w-full flex flex-row gap-[8px] items-center justify-center p-[24px] py-[48px]'>
                        <div className='font-bold mr-[24px]'>字體大小</div>
                        <button className='bg-[#108B96] rounded-[8px] text-white w-[37px] h-[37px] flex items-center justify-center font-[900] text-[32px] pb-[8px]'
                            onClick={() => {
                                if (fontSize <= 14) return
                                updateFontSize(fontSize - 2)
                            }}
                        >-</button>
                        <input className='flex-1 max-w-[200px]' type='range' min={14} max={22} step={2} value={fontSize} onChange={(e) => updateFontSize(Number(e.target.value))} />
                        <button className='bg-[#108B96] rounded-[8px] text-white w-[37px] h-[37px] flex items-center justify-center font-[900] text-[36px] pb-[2px]' onClick={
                            () => {
                                if (fontSize >= 22) return
                                updateFontSize(fontSize + 2)
                            }
                        }>+</button>
                    </div>
                    <div className='flex flex-row px-[32px] items-center flex-wrap justify-center gap-[16px] mt-[48px]'>
                        <button className='bg-white rounded-full py-[8px] px-[20px] flex flex-row items-center gap-[16px] text-[#34778C] font-[700]' style={{ boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)' }}>
                            <img src='/secondary/b1.png' alt='' className='h-[32px] w-[32px]' />
                            常見探究
                        </button>
                        <button className='bg-white rounded-full py-[8px] px-[20px] flex flex-row items-center gap-[16px] text-[#34778C] font-[700]' style={{ boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)' }}>
                            <img src='/secondary/b2.png' alt='' className='h-[32px] w-[32px]' />
                            使用條款
                        </button>
                        <button className='bg-white rounded-full py-[8px] px-[20px] flex flex-row items-center gap-[16px] text-[#34778C] font-[700]' style={{ boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)' }}>
                            <img src='/secondary/b3.png' alt='' className='h-[32px] w-[32px]' />
                            私隱條款
                        </button>
                        <button className='bg-white rounded-full py-[8px] px-[20px] flex flex-row items-center gap-[16px] text-[#34778C] font-[700]' style={{ boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)' }}>
                            <img src='/secondary/b4.png' alt='' className='h-[32px] w-[32px]' />
                            聯絡我們
                        </button>
                    </div>
                    <div className='flex flex-row items-center gap-[8px]'>
                        {props.enableReturn && <button className='mt-[48px] px-[48px] py-[6px] text-white rounded-full font-[700] noto-san-hk' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }} onClick={props.onReturn}>
                            返回
                        </button>}
                        <button className='mt-[48px] px-[48px] py-[6px] text-white rounded-full font-[700] noto-san-hk' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }} onClick={props.onClose}>
                            離開
                        </button>
                    </div>

                </div>

            </div>
        </div>
    )
}